var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.2002C16.8302 1.2002 21.5 5.60262 21.5 10.9541C21.4999 13.1394 20.8386 15.5616 19.8203 17.9873C18.804 20.4083 17.4444 22.8027 16.0791 24.9238C14.7146 27.0437 13.3497 28.8827 12.3252 30.1914C11.8131 30.8455 11.3867 31.3667 11.0889 31.7236C11.0581 31.7605 11.0279 31.7948 11 31.8281C10.9721 31.7948 10.9419 31.7605 10.9111 31.7236C10.6133 31.3667 10.1869 30.8455 9.6748 30.1914C8.65027 28.8827 7.28542 27.0437 5.9209 24.9238C4.55556 22.8027 3.19601 20.4083 2.17969 17.9873C1.16145 15.5616 0.500067 13.1394 0.5 10.9541C0.5 5.60262 5.1698 1.2002 11 1.2002ZM12.8809 7.42285C11.9835 7.03793 10.9949 6.93734 10.041 7.13379C9.08717 7.3303 8.21335 7.81499 7.5293 8.52344C6.84547 9.23168 6.38116 10.1318 6.19336 11.1094C6.00562 12.0869 6.10206 13.1006 6.4707 14.0225C6.83938 14.9443 7.46478 15.7352 8.27051 16.293C9.07669 16.8509 10.0269 17.1504 11 17.1504H11.001C12.3056 17.1488 13.5528 16.6108 14.4697 15.6611C15.3861 14.712 15.8989 13.4287 15.9004 12.0938V12.0928C15.9003 11.0965 15.6152 10.1211 15.0791 9.29004C14.5428 8.45874 13.7782 7.8078 12.8809 7.42285Z",
    fill: "#ED870F",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 12.2502,
    r: 6.05,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71875 9.51953L13.1812 14.9819",
    stroke: "#ED870F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1812 9.51953L7.71875 14.9819",
    stroke: "#ED870F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon4);
export default __webpack_public_path__ + "static/media/OutletIcon4.62224770464b264385f8db3ec4d15124.svg";
export { ForwardRef as ReactComponent };